import React, { ChangeEvent, FC, useContext, useState } from 'react';
import { LoadingButton } from '@mui/lab';

import {
  Autocomplete,
  Box,
  FormHelperText,
  Link,
  TextField,
  Typography,
} from '@mui/material';
import { useDispatch, useSelector } from 'src/store';
import { useHistory } from 'react-router';
import { DoisFatoresContext } from 'src/Areas/Genericos/GE/contexts/DoisFatoresContext';
import { login } from 'src/Areas/Genericos/GE/slices/account';
import { useSettings } from '@cigam/template/dist/hooks/useSettings';

interface Props {
  setTelaAtiva: (telaAtiva: string) => void;
}

interface PerguntasProps {
  id: number;
  pergunta: string;
}

const PerguntaSeguranca: FC<Props> = ({ setTelaAtiva }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { settings } = useSettings();
  const { historyNavigation } = useSelector(state => state);
  const { username, password } = useContext(DoisFatoresContext);
  const [loading, setLoading] = useState(false);
  const [erro, setErro] = useState('');
  const [perguntaSelecionada, setPerguntaSelecionada] =
    useState<PerguntasProps | null>(null);
  const [resposta, setResposta] = useState('');
  const portalAtivo = settings.activePortals[0];

  const perguntas = [
    { id: 1, pergunta: 'Qual a cor do seu primeiro carro?' },
    { id: 2, pergunta: 'Qual era o seu apelido de infância?' },
    { id: 3, pergunta: 'Qual a sua flor preferida?' },
    { id: 4, pergunta: 'Qual é o seu herói favorito?' },
    { id: 5, pergunta: 'Qual comida você mais gosta?' },
    { id: 6, pergunta: 'Qual o nome do seu primeiro animal de estimação?' },
    { id: 7, pergunta: 'Qual a cidade sonha em morar?' },
    { id: 8, pergunta: 'Qual o nome da empresa do seu primeiro emprego?' },
  ];

  const handleChangeAuth = () => {
    setErro('');
    setTelaAtiva('administrador');
  };

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    setResposta(event.target.value);
    setErro('');
  };

  const handleAutocomplete = (value: any | null) => {
    setPerguntaSelecionada(value);
  };

  const handleSubmit = async () => {
    setLoading(true);
    try {
      await dispatch(
        login(
          username,
          password,
          portalAtivo,
          '',
          perguntaSelecionada ? perguntaSelecionada.id : 0,
          resposta
        )
      );
      history.push(historyNavigation.pathname);
      setLoading(false);
    } catch {
      setErro('Pergunta ou resposta secreta inválida.');
      setLoading(false);
    }
  };

  return (
    <Box>
      <Typography variant="h4" color="textPrimary">
        Autenticação em Duas Etapas
      </Typography>
      <Typography variant="body1" color="textPrimary" mt={2}>
        Selecione abaixo a sua pergunta de segurança e informe a resposta para
        prosseguir.
      </Typography>
      <Autocomplete
        sx={{ marginTop: 4 }}
        value={perguntaSelecionada}
        options={perguntas}
        getOptionLabel={option => option.pergunta}
        fullWidth
        renderInput={params => (
          <TextField {...params} label="Pergunta de Segurança" />
        )}
        onChange={(_event, value) => {
          handleAutocomplete(value);
        }}
        isOptionEqualToValue={option => option.id === perguntaSelecionada!.id}
      />
      <TextField
        sx={{ marginTop: 4, marginBottom: 4 }}
        fullWidth
        autoFocus
        label="Resposta"
        margin="normal"
        name="resposta"
        type="text"
        onChange={handleChange}
        value={resposta}
        onKeyDown={event => {
          if (event.key === 'Enter') handleSubmit();
        }}
      />
      <Link
        sx={{ cursor: 'pointer', marginTop: 2 }}
        underline="none"
        color="inherit"
        variant="body1"
        onClick={handleChangeAuth}
      >
        Tentar de outra forma
      </Link>
      <LoadingButton
        sx={{ marginTop: 4 }}
        fullWidth
        size="large"
        type="submit"
        variant="contained"
        loading={loading}
        onClick={handleSubmit}
      >
        Confirmar
      </LoadingButton>
      {erro && (
        <Box mt={2}>
          <FormHelperText error>{erro}</FormHelperText>
        </Box>
      )}
    </Box>
  );
};
export default PerguntaSeguranca;
